import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const APP_TIMEZONE = 'Europe/Kyiv';

export interface CancelTranslationItem {
  createdAt: string;
  updatedAt: string;
  translator: {
    id: string;
    userName: string;
    avatarUrl: string;
  };
  comment: string;
}

// Єдина точка конвертації локального діапазону дат (день у Києві) → UTC-межі для API.
// Початок = 00:00:00, кінець = 23:59:59.999 обраного дня (включно), Київ → UTC.
// Замінює розкидані хардкоди +3 год / ±1 день.
export const kyivDateRangeToUtc = (
  startDate?: string,
  endDate?: string,
): { startUtc?: string; endUtc?: string } => ({
  startUtc: startDate
    ? dayjs
        .tz(startDate, 'YYYY-MM-DD', APP_TIMEZONE)
        .startOf('day')
        .utc()
        .toISOString()
    : undefined,
  endUtc: endDate
    ? dayjs
        .tz(endDate, 'YYYY-MM-DD', APP_TIMEZONE)
        .endOf('day')
        .utc()
        .toISOString()
    : undefined,
});
